import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon.js';

interface EmptyStateProps {
  icon: IconName;
  title: string;
  description?: string;
  /** A button or link that resolves the emptiness. */
  action?: ReactNode;
  /** Tighter variant, for panels rather than whole columns. */
  compact?: boolean;
}

/**
 * The "nothing here yet" panel.
 *
 * One component for every empty surface in the app, because the previous
 * treatment - a single grey sentence - was the main reason the product read as
 * unfinished. An empty state should say what is missing and what to do next.
 */
export function EmptyState({ icon, title, description, action, compact = false }: EmptyStateProps) {
  return (
    <div className={compact ? 'empty-state empty-state--compact' : 'empty-state'}>
      <span className="empty-state-icon">
        <Icon name={icon} size={compact ? 20 : 26} />
      </span>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
      {action}
    </div>
  );
}
